import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

export const Ultra24OverviewSection = () => {
  const eventDateString = "15 – 16 Agustus 2026";
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "center center"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [120, 0]);

  return (
    <section ref={ref} id="event-overview" className="w-full py-16 bg-white">
      <motion.div className="container mx-auto px-4 sm:px-6" style={{ y }}>
        {/* Mobile: Title */}
        <div className="md:hidden text-center">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500">INDONESIA ULTRA 24</p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mt-3 mb-4">
            About the Event
          </h2>
        </div>

        {/* Mobile: Description */}
        <div className="md:hidden text-center">
          <p className="text-base text-gray-700 mb-4 leading-relaxed">
            INDONESIA ULTRA 24 adalah ajang ultra running 24 jam non-stop di lintasan ring stadion yang menghadirkan format kompetisi endurance terukur dan spektakuler. Event ini ditargetkan mencetak rekor MURI, memperkuat kalender lari nasional, dan tumbuh menuju skala internasional.
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
            {/* Left Column */}
            <div className="space-y-4 order-3 md:order-1">
              <div className="hidden md:block text-center md:text-left">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500">INDONESIA ULTRA 24</p>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mt-3">
                  About the Event
                </h2>
              </div>
              <p className="hidden md:block text-base md:text-lg text-gray-700 leading-relaxed text-center md:text-left">
                INDONESIA ULTRA 24 adalah ajang ultra running 24 jam non-stop di lintasan ring stadion yang menghadirkan format kompetisi endurance terukur dan spektakuler. Event ini ditargetkan mencetak rekor MURI, memperkuat kalender lari nasional, dan tumbuh menuju skala internasional.
              </p>
            </div>

            {/* Right Column: Date and Location Details */}
            <div className="flex flex-col gap-4 items-center md:items-start text-center md:text-left order-2 md:order-2">
              <div className="space-y-2 bg-white border border-slate-200 rounded-2xl p-4 w-full max-w-lg">
                <div className="flex items-center justify-center md:justify-start">
                  <FontAwesomeIcon icon={faCalendarAlt} className="text-2xl text-slate-600 mr-3" />
                  <p className="text-sm md:text-base font-medium text-slate-600 uppercase">DATE</p>
                </div>
                <p className="text-lg md:text-xl font-semibold text-slate-900">{eventDateString}</p>
                <p className="text-sm text-gray-600 leading-relaxed">Indomilk Arena Stadium · Main Event</p>
               {/*  <p className="text-sm md:text-lg font-semibold text-slate-700 mt-2 leading-relaxed">
                  Categories: 24H Solo/Relay · 12H Solo/Relay · 6H Solo · Relay 4x6H
                </p> */}
              </div>
              <div className="space-y-2 bg-white border border-slate-200 rounded-2xl p-4 w-full max-w-lg">
                <div className="flex items-center justify-center md:justify-start">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="text-2xl text-slate-600 mr-3" />
                  <p className="text-sm md:text-base font-medium text-slate-600 uppercase">LOCATION</p>
                </div>
                <p className="text-lg md:text-xl font-semibold text-slate-900">Indomilk Arena Stadium</p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Tangerang, Banten · Indonesia
                  <br />
                  Professional athletics track with international standards
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

